/* eslint-disable react/require-default-props */
import React, { createContext, useContext, useEffect } from 'react';
import useSWR from 'swr';
import { useAbTest } from './AbTest';
const ExperimentContext = createContext({});
export const useExperiment = () => useContext(ExperimentContext);
export const useVariant = () => { var _a; return (_a = useContext(ExperimentContext)) === null || _a === void 0 ? void 0 : _a.variant; };
const useGenerateVariant = (experimentName, swrConfig = {}) => {
    const { generateVariant } = useAbTest();
    const { data: variant, mutate } = useSWR(`ab-generateVariant-${experimentName}`, () => generateVariant === null || generateVariant === void 0 ? void 0 : generateVariant(experimentName), Object.assign({ dedupingInterval: 1000 * 60 * 90, revalidateOnMount: true, suspense: true }, swrConfig));
    useEffect(() => {
        generateVariant === null || generateVariant === void 0 ? void 0 : generateVariant(experimentName).then((res) => mutate(res, false));
    }, [generateVariant, mutate, experimentName]);
    return variant;
};
const getExperimentContextValue = (variant, name, defaultVariant) => ({
    name,
    variant: variant || defaultVariant,
});
const Experiment = ({ name, defaultVariant, swrConfig = {}, children, }) => {
    const variant = useGenerateVariant(name, swrConfig);
    return (React.createElement(ExperimentContext.Provider, { value: getExperimentContextValue(variant, name, defaultVariant) }, children));
};
export default Experiment;
